/**
 * Accordion Publications Block.
 */
class BlockAccordion {
	constructor(container) {
		if (typeof container === 'undefined' || container === null) {
			return;
		}
		this.container = container;
		this.children = Object.values(this.container.children);
		this.target = '';
	}

	pageLoadHandler() {
		window.addEventListener('load', () => {
			this.target = this.container.querySelector('[data-open="true"]');
			this.openItem();
		});
	}

	clickHandler() {
		this.children.forEach((child) => {
			child.addEventListener('click', (e) => {
				const target = e.target.closest('[data-open]');
				if (target.dataset.open === 'false') {
					this.target = target;
					this.openItem();
				} else {
					this.target = target;
					this.closeItem();
				}
			});
		});
	}

	openItem() {
		const { target } = this;
		target.setAttribute('data-open', 'true');
		const accordionContainer = target.querySelector('article');
		accordionContainer.style.maxHeight = `${accordionContainer.scrollHeight}px`;
	}

	closeItem() {
		const { target } = this;
		target.setAttribute('data-open', 'false');
		target.querySelector('article').style.maxHeight = null;
	}

	load() {
		this.pageLoadHandler();
		this.clickHandler();
	}
}

const blockAccordions = {
	init() {
		const containers = [
			document.querySelectorAll('.em-accordion-publications__accordion-container'),
			document.querySelectorAll('.board-people__accordion'),
		];

		if (containers.length) {
			containers.forEach((container) => {
				if (container.length) {
					const accordion = new BlockAccordion(container[0]);
					accordion.load();
				}
			});
		}
	},
};

blockAccordions.init();
